import React from 'react';
import Page from "@/components/layout/Page";
import StaticContent from '@/components/common/StaticContentPage';

const InfiniteHelp = () => {
	return (
		<Page pageTitle='Trivia Playlists'>
      <StaticContent header={'Trivia Playlists'}>
				<div>
					<h3 className={`font-gSemi text-base`}>{`What's a Trivia Playlist?`}</h3>
					<p className='font-gReg text-base'>{`Imagine crafting your very own trivia adventure, tailored just for you or to challenge your friends. That's exactly what our Trivia Playlists are all about!`}</p>
				</div>
				<div>
					<p className='font-gReg text-base'>{`Whether you're a history buff, a science geek, or a pop culture enthusiast, your Trivia Playlist can be as unique as you are.`}</p>
				</div>
				<div>
					<h3 className={'font-gSemi text-base mb-2'}>{`How to create your Trivia Playlist:`}</h3>
					<ul className={'list-disc mx-6 flex flex-col gap-2'}>
						<li className='font-gReg text-base'>{`To make a Trivia Playlist, enter any subject or theme you can imagine.`}</li>
						<li className='font-gReg text-base'>{`Our AI will generate 6 questions based on your chosen topic.`}</li>
						<li className='font-gReg text-base'>{`You can make, play, and share up to 3 unique Trivia Playlists per day.`}</li>
					</ul>
				</div>
			</StaticContent>
		</Page>
	);
};

export default InfiniteHelp;
